module.exports = __webpack_public_path__ + "static/media/356JamesPBrawleyDrNW_2018-06-11_73.20a9ca5e.jpg";